"use client";

import { usePathname } from "@/i18n/navigation";
import AsciiPulse from "./AsciiPulse";

export default function FooterMascot() {
    const pathname = usePathname();
    if (pathname?.startsWith("/dog")) return null;
    return <AsciiPulse />;
}
